// extracted by mini-css-extract-plugin
export default {"basic-panel":"ModalDeletePolicy_basic-panel__9tzhd","title":"ModalDeletePolicy_title__8gSsg","text":"ModalDeletePolicy_text__mFHwP"};